import lang from "@/views/modules/InstitutionalDocs/language/en";

//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-ed-request",
   
    components: {
     //   'editor': Editor,
    },
    data() {
        return {
            loading: true,
            requests: {
                status:'Active',
            },
            lang:[],
            error_message:{
                document_title:'',
                document_sequence:''
            },
            showDropdown:null,
            dom_array:[],
            process:false,
           
            allFiles:[],
            fileName: [],
            fileUpload: false,
            file_error:'',
        }
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
      
    },
    methods: {
        saveRequest() {
            const self = this;
            self.loading = true;
         
            let fileName = self.fileName;
          
                self.process = true;

                let formData = new FormData();                
                formData.append('file', self.allFiles);  // Add your form data
                self.requests.filelist = self.allFiles;

                axios.post('api/modules/institutionaldocs', self.requests, formData, {headers: { 'Content-Type': 'multipart/form-data' }}).then(function (response) {
                    self.loading = false;
                    self.process = false;
                    self.$router.push('/modules/institutionaldocs');
                }).catch(function () {
                    self.loading = false;
                    self.process = false;
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                      
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                });
           
        },
       
        changeFile(e) {
            let filelist = e.target.files;
            this.file_error = '';
            for(let i = 0; i < filelist.length; i++){
                let image = e.target.files[i];
                // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    this.file_error = `File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;
                    return;
                }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.fileName = file_type_arr;
                this.showFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes

                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(fileSize <= definedSize)
                {
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                //  this.file_content = e.target.result;
                    this.fileUpload = true;
                    fileArr.push(e.target.result, this.fileUpload, file_type_arr[1], image.name);
                    this.allFiles.push(fileArr);
                    }; 
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }
            }
        },
    }
}